import styled from 'styled-components';
import { Button } from '@dsny/dsny-component-library';
import { device } from 'src/styles/global';

export interface Props {
  hasComparisonOn?: boolean;
}

export const AddNewTrackWrapper = styled.div<Props>`
  display: none;

  @media ${device.mobile} {
    display: flex;
    width: 100%;
  }

  @media ${device.tablet} {
    display: flex;
    width: 100%;
  }

  @media ${device.ipad} {
    display: none;
  }
`;

export const AddNewTrackButton = styled(Button)`
  width: 100%;
  svg {
    width: 18px;
    height: 18px;
    padding-bottom: 2px;
  }
`;
